import type { Person, PersonRole } from '@/store/persons/person.dto';

export const getPersonServiceEntry = (
  person: Person,
  serviceId: string,
): PersonRole | undefined => {
  return person.services?.find((s) => s.service_id === serviceId);
};

export const getPersonRoleForService = (person: Person, serviceId: string): string => {
  const entry = getPersonServiceEntry(person, serviceId);
  if (!entry) return '';
  return typeof entry.role === 'string' ? entry.role : String(entry.role);
};

export const getPersonServiceTypeForService = (person: Person, serviceId: string): string => {
  return getPersonServiceEntry(person, serviceId)?.service_type ?? '';
};

export const getPersonRightsForService = (person: Person, serviceId: string): string[] => {
  return getPersonServiceEntry(person, serviceId)?.rights ?? [];
};

/**
 * The subscription seat the person occupies on this service, which decides which
 * permissions they may hold at all. `null` when they have no membership of it.
 */
export const getPersonSeatTypeForService = (person: Person, serviceId: string): string | null => {
  return getPersonServiceEntry(person, serviceId)?.seat_type ?? null;
};

export const getPersonFullName = (person: Person): string => {
  const first = person.person_info?.first_name ?? '';
  const last = person.person_info?.last_name ?? '';
  return `${first} ${last}`.trim() || 'Unnamed';
};
